import React from 'react';
import { useFeatureFlag } from '@features/user';

import { RequestPaymentButton, type RequestPaymentButtonProps } from './RequestPaymentButton';

/**
 * Wrapper component that conditionally renders RequestPaymentButton
 * based on the stripe_connect feature flag
 */
export const RequestPaymentButtonWrapper: React.FC<RequestPaymentButtonProps> = props => {
  const stripeConnectFeatureFlag = useFeatureFlag('stripe_connect');

  // Return null if stripe_connect feature flag is not enabled
  if (!stripeConnectFeatureFlag) {
    return null;
  }

  return <RequestPaymentButton {...props} />;
};
